// extracted by mini-css-extract-plugin
export default {"accessDeniedSection":"access_accessDeniedSection__zooo3","subText":"access_subText__7mLcv","accessHeading":"access_accessHeading__s3RNq"};